import { connect } from 'react-redux'
import at from 'lodash/at'
import get from 'lodash/get'
import sortBy from 'lodash/sortBy'
import debounce from 'lodash/debounce'

import { searchAvailableAreasByWorkOrder } from '../../actions/areas'

import AreaSelector from './area-selector'

function mapStateToProps (state, ownProps) {
  const workOrderId = ownProps.workOrderId
  const location = state.locations[ownProps.locationId]

  if (!location) return { options: [] }

  const allAreas = at(state.areas, location.areas || [])
  const sortedAreas = sortBy(allAreas, 'name')
  const pagination = get(state.pagination, `areasByLocation.${location.id}-${workOrderId}-search`, {})

  if (pagination.ids) {
    var searchableValues = pagination.ids
  }

  const options = sortedAreas.map((area) => ({
    value: area.id,
    disabled: !area.availableForWorkOrder,
    label: area.name,
    subLabel: area.availableForWorkOrder
      ? (!area.lastOvercleaningDate
        ? null
        : `${area.lastOvercleaningServiceNames} done on ${area.lastOvercleaningDate.format('MMM Do')}`) 
      : 'Already in work order.',
    subLabelWarning: area.availableForWorkOrder && !!area.lastOvercleaningDate
  }))

  return {
    options,
    searchableValues
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const workOrderId = ownProps.workOrderId

  let searchValue = ''

  const debouncedSearch = debounce(
    () => {
      dispatch(
        searchAvailableAreasByWorkOrder(workOrderId, searchValue, false)
      )
    }
    , 750
  )

  return {
    onInputChange (value) {
      searchValue = value
      debouncedSearch()
    },

    onScrollNearBottom (event) {
      dispatch(
        searchAvailableAreasByWorkOrder(workOrderId, searchValue, true)
      )
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AreaSelector)



// WEBPACK FOOTER //
// ./src/containers/forms/area-selector-container.js